var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaygSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 62,
    cy: 61,
    r: 40,
    fill: "#009980"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5738 89.5994L12.8008 58.8834L23.136 48.5624L43.8158 69.2L90.7075 22.4L100.801 32.4784L43.5738 89.5994Z",
    fill: "#00CCAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6618 69.5539L51.015 69.9064L51.3682 69.5539L97.9067 23.1065L107.292 32.4783L50.773 88.893L20.7077 58.8833L30.3354 49.2689L50.6618 69.5539Z",
    stroke: "#FAE451"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7871 83.5601L12.0756 78.7155L20.3473 74.3981L15.7871 83.5601Z",
    fill: "#419FFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.689 43.2311L121.48 47.2209L113.599 47.2747L119.689 43.2311Z",
    fill: "#FAE451"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.363 52.048L113.922 55.7018L110.755 51.2195L116.363 52.048Z",
    fill: "#419FFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14389 66.7229L5.46025 71.1058L15.1919 71.2412L5.14389 66.7229Z",
    fill: "#F343A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaygSuccess);
export default __webpack_public_path__ + "static/media/payg-success.9fe15e3508166067168cece939fdb723.svg";
export { ForwardRef as ReactComponent };